export var MapTheme = {
  dark: 'amap://styles/c9f1d10cae34f8ab05e425462c5a58d7?isPublic=true',
  light: 'amap://styles/c422f5c0cfced5be9fe3a83f05f28a68?isPublic=true',
  normal: 'amap://styles/normal',
  blank: 'amap://styles/07c17002b38775b32a7a76c66cf90e99?isPublic=true'
};